export const MS_OCIOSO_CONSUMO = 30_000

export const MS_OCIOSO_CATALOGO_VAZIO = 60_000

export const MS_OCIOSO_COM_ITENS = 90_000

export const AVISAR_COM_CARRINHO_VAZIO = true
